// eslint-disable-next-line import/prefer-default-export
export const EDITION_REMISE = {
  title: 'Ajouter une remise personnalisée',
  modeManuel: 'Mode manuel',
  prixDepart: 'Prix de départ',
  modeAAtteindre: 'Je cherche à atteindre un montant',
  prixAAtteindre: 'Prix à atteindre',
  applyOn: 'Appliquer ma remise sur',
  allProduct: 'Tous les produits',
  selectProduct: 'Type de produit',
  informations: 'Informations',
  messageInformation: 'Vous avez {nbLigne} ligne(s) sans produit, il n\'est pas possible d\'appliquer une remise ou une majoration sur ces lignes.',
  typeLigne: {
    location: 'Location',
    divers: 'Divers',
    tlpe: 'Tlpe',
  },
  label: 'Libellé',
  discount: 'Remise',
  majoration: 'Majoration',
  discountType: 'le type de remise',
  type: 'Mode de calcul',
  add: 'Ajouter la remise',
  sousTotal: 'Ajouter une ligne de sous total',
  amount: 'Montant',
  deleteLine: 'Supprimer ma ligne',
  duplicateLine: 'Dupliquer ma ligne',
  problemAddOccurred: 'L\'ajout est impossible. Les champs suivants sont obligatoires : ',
  total: 'Total',
  totalRemise: 'Total remisé',
  noResults: 'Aucune remises',
  actions: {
    revert: 'Annuler',
    validate: 'Terminer',
  },
  errors: {
    prixNetFaceSouhaiteNull: 'Impossible d\'obtenir un prix net face sans prix net face souhaitée',
    prixAAtteindreNull: 'Impossible d\'obtenir une remise sans prix à atteindre',
  },
  remisePrixDepartZero: 'Impossible d\'ajouter une remise avec un prix de départ à 0',
  modePrixNetFace: {
    title: 'Je cherche à obtenir un prix net face',
    libelle: 'Libellé',
    facePropose: 'Nb faces proposées',
    prixTotal: 'Prix total',
    prixNetFace: 'Prix net face actuel',
    prixNetFaceSouhaite: 'Prix net face souhaitée',
    actions: {
      add: 'Ajouter',
    },
  },
};
